import { Component, OnInit, HostListener } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { ReintegrosService } from "src/app/services/reintegros.service";
import * as _moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
const moment = (_moment as any).default ? (_moment as any).default : _moment;
declare let $: any;

@Component({
  selector: "app-reintegros",
  templateUrl: "./reintegros.component.html",
  styleUrls: ["./reintegros.component.scss"]
})
export class ReintegrosComponent implements OnInit {

  public data: any = {};
  public title = "CoviRecupera";
  public blankState = true;
  public min = new Date("2016-01-02");
  public max = new Date();
  public selectedDetail: any;
  public onCharge = true;
  public searchString: any;
  public totalRefunds: any;
  public totalClients: any;
  affiliate = {
    contrato: "",
    fecha_inicio: "",
    fecha_fin: ""
  };

  date: any;
  date1: any;
  date2: any;

  public selectedMoments = [];
  public dataAffiliate: any;
  public dataRefunds: any;
  public dataWebContracts: any;
  public showLogout: boolean;
  public identity: any;
  public analytics: any;

  // Declare height and width variables
  innerWidth: any;
  screenHeight: any;
  isShowWidth: boolean;
  elementId = "";
  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    this.screenHeight = window.innerHeight;
    this.innerWidth = window.innerWidth;

    if (this.innerWidth >= 900) {
      this.isShowWidth = true;
      this.elementId = "tableFixed";
    } else {
      this.isShowWidth = false;
      this.elementId = "";
    }
  }

  constructor(
    private refundsService: ReintegrosService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.analytics = JSON.parse(localStorage.getItem("identityCVE"));
    this.innerWidth = window.innerWidth;
    if (this.innerWidth >= 900) {
      this.isShowWidth = true;
      this.elementId = "tableFixed";
    } else {
      this.isShowWidth = false;
      this.elementId = "";
    }
  }

  handleFilter(value: string) {
    this.searchString = value;
  }

  // 1. Buscar
  getRefunds({ fechaInicial, fechaFinal }) {
    (window as any).gtag("event", "buscar_reintegros", {
      event_category: `${this.analytics.v_tipo_documento} ${this.analytics.v_documento}`,
      event_label: ""
    });

    this.date1 = moment(fechaInicial, "DD/MM/YYYY").format("DD/MM/YYYY");
    this.date2 = moment(fechaFinal, "DD/MM/YYYY").format("DD/MM/YYYY");

    this.affiliate.fecha_inicio = this.date1;
    this.affiliate.fecha_fin = this.date2;
    this.spinner.show("reintegros");
    const data = this.data;
    this.refundsService.getRefunds(this.affiliate).subscribe(
      (resp: any) => {
        this.dataRefunds = resp;
        this.spinner.hide("reintegros");

        if (resp === undefined) {
          this.affiliate.fecha_inicio = "";
          this.affiliate.fecha_fin = "";

          this.blankState = true;

          return;
        } else {
          this.totalClients = resp.length || 0;
          this.blankState = false;

          // Calcular
          const items = JSON.stringify(this.dataRefunds);
          const data = JSON.parse(items);
          let suma = 0;
          for (let x in data) {
            suma += Number(data[x].VALOR);
          }

          const total = suma;
          this.totalRefunds = suma || 0;
          // ./ Calcular
          this.spinner.hide("reintegros");
        }
      },
      (err: any) => {
        this.spinner.hide("reintegros");
        this.blankState = true;
        const errorMessage = $(err.error)
          .last()
          .text();
        this.toastr.warning(errorMessage, "", {
          timeOut: 4000
        });
      }
    );
  }

}
